<template>
	<div class="index">
		<div class="djxxDetail_wrap">
			<!-- 上方新闻信息 -->
			<div class="top_content">
				<div class="left_pic">
					<img :src="djxxDetail.sz_img" alt="">
				</div>
				<div class="right_content">
					<div class="right_content_top">
						<div class="right_content_top_left">
							{{ djxxDetail.title }}
						</div>
						
					</div>
					<div class="right_content_center">

					</div>
					<div class="right_content_top_right_box">
						<div class="right_content_top_right">{{ $route.query.title }}</div>
						<div v-if="$route.query.id==174" @click="gopicDetail" class="right_content_top_right" style="margin-left: 10px;cursor: pointer;">修订条文对照表</div>
					</div>
					<!-- 下方课程信息 -->
					<div class="dataList_item_bottom_botom">
						<div class="dataList_item_bottom_botom_item">
							<div class="dataList_item_bottom_botom_item_icon">
								<img src="../../assets/xiangning/djxx_detail/icon_1.png" alt="">
							</div>
							<div class="dataList_item_bottom_botom_item_content">
								共{{ djxxDetail.count }}课
							</div>
						</div>
						<div class="dataList_item_bottom_botom_item">
							<div class="dataList_item_bottom_botom_item_icon">
								<img src="../../assets/xiangning/djxx_detail/icon_3.png" alt="">
							</div>
							<div class="dataList_item_bottom_botom_item_content">
								{{ djxxDetail.hours }}课时
							</div>
						</div>
						<div class="dataList_item_bottom_botom_item">
							<div class="dataList_item_bottom_botom_item_icon">
								<img src="../../assets/xiangning/djxx_detail/icon_2.png" alt="">
							</div>
							<div class="dataList_item_bottom_botom_item_content">
								{{ djxxDetail.nums }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 下方课程列表 -->
			<div class="bottom_List">
				<!-- 课程目录标题 -->
				<div class="bottom_List_title">
					<div class="title_left">
						<img src="../../assets/xiangning/home/titile_left.png" alt="">
					</div>
					<div class="bottom_List_title_center">课程目录</div>
					<div class="right_back" @click="$router.go(-1)">
						<div class="right_back_icon"><img src="../../assets/xiangning/newsCenter/back.png" alt=""></div>
						<div>返回</div>
					</div>
				</div>
				<!-- 课程目录内容 -->
				<div class="bottom_List_main">
					<!-- 每一个课程 -->
					<div class="bottom_List_main_item" @click="geDjxxResouce(item)" v-for="item in djxxFileList">
						<!-- 圆形改变颜色可根据数据改变圆形的颜色-->
						<div :style="{ borderColor: true ? '#64C59C' : '' }" class="bottom_List_main_item_cicrl">
							<!-- 内侧圆心颜色 -->
							<div :style="{ backgroundColor: true ? '#64C59C' : '' }"
								class="bottom_List_main_item_cicrl_inter">
							</div>
						</div>
						<div class="bottom_List_main_item_lefttitle">{{ item.title }}</div>
						<!-- 右侧学习时长 -->
						<div class="bottom_List_main_item_right">
							<!-- 左侧资源类型图标 -->
							<div class="bottom_List_main_item_right_time" v-if="$route.query.id != 174">
								{{ item.dur }}
							</div>
							<div class="bottom_List_main_item_right_time"  v-if="$route.query.id == 174">
                              音频资源
							</div>
							
							<!-- pdf类型 -->
							<div class="bottom_List_main_item_right_pic" v-if="item.bsid == '8'">
								<img src="../../assets/xiangning/djxx_detail/pdf.png" alt="">
							</div>
							<!-- 图片类型 -->
							<div class="bottom_List_main_item_right_pic" v-if="item.bsid == '2'">
								<img src="../../assets/xiangning/djxx_detail/pic.png" alt="">
							</div>
							<!-- 视频类型 -->
							<div class="bottom_List_main_item_right_pic" v-if="item.bsid == '3'">
								<img src="../../assets/xiangning/djxx/video.png" alt="">
							</div>
							<!-- ppt -->
							<div class="bottom_List_main_item_right_pic" v-if="item.bsid == '1' ">
								<img src="../../assets/xiangning/djxx/ppt.png" alt="">
							</div>
							<div class="bottom_List_main_item_right_pic" v-if="item.bsid == '4'">
								<img src="../../assets/xiangning/djxx/audio.png" alt="">
							</div>
							<div class="progress" v-if="item.times!=0&item.times!=null">
								<div class="progress_content">已学：</div>
								<div class="progress_item"><el-progress
										:percentage="Math.floor(Number(item.seen) * 100 / Number(item.times))"
										:color="customColors"></el-progress></div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Swiper from 'swiper';
import { news } from '@/axios';
import Page from '@/components/page.vue'
export default {
	data() {
		return {
			// 总数据条数
			total: 100,
			// 当前页码
			per_page: 1,
			index: 0,
			input: '',
			type: 'pdf',
			djxxDetail: {},
			djxxFileList: [],			// 进度条
			customColors: [
				{ color: '#f56c6c', percentage: 20 },
				{ color: '#e6a23c', percentage: 40 },
				{ color: '#5cb87a', percentage: 60 },
				{ color: '#1989fa', percentage: 80 },
				{ color: '#6f7ad3', percentage: 100 }
			]
		}

	},
	components: { Page },
	methods: {
		format(percentage) {
			return percentage === 100 ? '满' : `${percentage}%`;
		},
		// 党建学习资源列表
		getDjxxdataList() {
			let that = this
			news.djxxdataList({
				id: that.$route.query.id, uid: this.$store.state.user.userinfo2.id,
				flag: this.$store.state.user.userinfo2.flag,
			}).then((res) => {
				if (res.code == 200) {

					that.djxxDetail = res.data
					that.djxxFileList = res.data.files
				}
			})
		},
		gopicDetail(){
			this.$router.push({
					path:'/audioDetail',
					query:{
						type1:'tldz',
						type:'djxx'
					

					}
				})
		},
		// 党建学习资源播放
		geDjxxResouce(data) {
			let that = this
			if (data.bsid==4) {
				this.$router.push({
					path:'/audioDetail',
					query:{
						id:data.id,
						flag:data.flag,
						type:'djxx'
					

					}
				})
			} else {
				this.$router.push({
					path: '/djxxResouce2',
					query: {
						id: data.id,
						two_id: that.$route.query.id,
						one_id: that.$route.query.one_id,
						flag: data.flag
					}
				})
			}

		}
	},
	mounted() {
		this.getDjxxdataList()
	},
	created() {
		// this.$emit("highLight",2,"","","");
	}
}
</script>

<style lang="scss">
@import '@/common/index.scss';


.index {
	width: 100%;

	.newsCenterBanenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}

	}

	div {
		box-sizing: border-box;
	}

	.djxxDetail_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;
		position: relative;
		margin-top: 20px;

		//上方课程信息
		.top_content {
			height: 242px;
			width: 100%;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.left_pic {
				width: 384px;
				height: 242px;

				img {
					width: 100%;
					height: 100%;
				}

			}

			.right_content {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: 182px;
				width: 792px;

				.right_content_top {
					height: 32px;
					width: 100%;
					/* background-color: pink; */
					display: flex;
					justify-content: space-between;

					.right_content_top_left {
						width: 512px;
						height: 100%;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						font-family: PingFangSC-Medium;
						font-size: 18px;
						font-weight: 800;
						letter-spacing: 0px;
						color: #000000;

					}

				}

				.right_content_center {
					width: 100%;
					height: 62px;
					overflow: hidden;
					text-overflow: ellipsis;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					line-height: 20px;
					text-align: justify;
					/* 浏览器可能不支持 */
					letter-spacing: 0px;
					color: #666666;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
				}

				.right_content_top_right_box {
					width: 100%;
					display: flex;
					justify-content: start;

					.right_content_top_right {
						max-width: 730px;
						height: 32px;
						font-family: PingFangSC-Regular;
						font-size: 16px;
						font-weight: normal;
						letter-spacing: 0em;
						color: #FFFFFF;
						padding: 5px 17px;
						background-color: #C9010A;
						border-radius: 261px;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
					}
				}

				.dataList_item_bottom_botom {
					height: 16px;
					width: 100%;
					display: flex;

					.dataList_item_bottom_botom_item {
						overflow: hidden;
						height: 100%;
						width: 74px;
						display: flex;
						justify-content: center;

						.dataList_item_bottom_botom_item_icon {
							height: 12px;
							width: 12px;
							margin-right: 2px;
							position: relative;

							img {
								position: absolute;
								top: 2.5px;
							}
						}

						.dataList_item_bottom_botom_item_content {
							font-family: PingFangSC-Regular;
							font-size: 12px;
							font-weight: normal;
							letter-spacing: 0em;
							color: #999999;
						}
					}

					.dataList_item_bottom_botom_item:nth-child(2) {
						border-left: 1px solid #ECEEF4;
						border-right: 1px solid #ECEEF4;
						;
					}

					.dataList_item_bottom_botom_item:nth-child(1) {
						display: flex;
						justify-content: start;
					}

					.dataList_item_bottom_botom_item:nth-child(3) {
						display: flex;
						justify-content: end;

						.dataList_item_bottom_botom_item_icon {
							height: 10px;
							width: 15px;
						}
					}
				}
			}
		}

		/* 下方课程列表 */
		.bottom_List_title {
			height: 32px;
			width: 100%;
			margin: 20px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-left: 32px;
			background: #FFF6F1;
			box-sizing: border-box;
			position: relative;

			.title_left {
				position: absolute;
				top: -5px;
				left: 0;
				height: 42px;
				width: 42px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.bottom_List_title_center {
				width: 100%;
				height: 22px;
				box-sizing: border-box;

				padding-left: 8px;
				font-family: PingFangSC-Medium;
				font-size: 16px;
				font-weight: 800;
				letter-spacing: 0.1em;
				color: #D31813;

			}

			.right_back {
				display: flex;
				font-family: PingFangSC-Regular;
				font-size: 12px;
				font-weight: normal;
				letter-spacing: 0em;
				color: #666666;
				margin-right: 10px;
				width: 50px;
			}

			.right_back:hover {
				font-weight: 800;
				color: #EE632B;
			}

			.right_back_icon {
				height: 10px;
				width: 12px;
				margin-right: 5px;
			}

			.right_back_icon img {
				height: 100%;
				width: 100%;
			}
		}

		.bottom_List_main {
			width: 100%;
			/* background-color: pink; */
			margin-top: 20px;
			padding-left: 24px;
			box-sizing: border-box;

			.bottom_List_main_item {
				position: relative;
				width: 100%;
				height: 54px;
				border-left: 2px solid #D8D8D8;
				padding-left: 26px;
				display: flex;
				justify-content: space-between;

				.bottom_List_main_item_cicrl {
					position: absolute;
					top: 5px;
					left: -8px;
					width: 14px;
					height: 14px;
					box-sizing: border-box;
					border-radius: 50%;
					border: 2px solid #D8D8D8;
					background-color: #FFFFFF;
					display: flex;
					justify-content: center;
					align-items: center;

					.bottom_List_main_item_cicrl_inter {
						height: 6px;
						width: 6px;
						box-sizing: border-box;
						border-radius: 50%;
						background-color: #D8D8D8;

					}

				}

				.bottom_List_main_item_lefttitle {
					width: 600px;
					height: 20px;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #000000;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.bottom_List_main_item_lefttitle:hover {
					color: #C9010A;
					font-weight: 800;
				}

				.bottom_List_main_item_right {
					height: 24px;

					box-sizing: border-box;
					display: flex;
					justify-content: start;

					.bottom_List_main_item_right_pic {
						height: 100%;
						/* width: 100%; */
						width: 24px;
						margin-right: 11px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.bottom_List_main_item_right_time {
						font-family: PingFangSC-Regular;
						font-size: 12px;
						font-weight: normal;
						text-align: center;
						letter-spacing: 0em;
						color: #787878;
						white-space: nowrap;
						line-height: 22px;
						width: 80px;
					}

					.progress {

						display: flex;
						align-items: center;

						.progress_content {
							width: 40px;
							font-family: PingFangSC-Regular;
							font-size: 12px;
							font-weight: normal;
							letter-spacing: 0em;

							color: #787878;
						}

						.progress_item {
							width: 200px;
						}
					}
				}
			}

			.bottom_List_main_item:nth-child(1) .bottom_List_main_item_cicrl {
				position: absolute;
				top: 0px;
				left: -8px;
				width: 14px;
				height: 14px;
				box-sizing: border-box;
				border-radius: 50%;
				border: 2px solid #D8D8D8;
			}

		}

	}
}
</style>
